import React from 'react';
import { cn } from '@anytag/shared-utils';
import { FormProvider } from './form-provider';
import { SectionTitle } from './section-title';

const Field = ({ className, ...restProps }: React.ComponentProps<'div'>) => (
  <div className={cn('field-wrapper', 'relative box-border flex-1 basis-0', className)} {...restProps} />
);

const Fields = ({ className, itemsPerRow, ...restProps }: React.ComponentProps<'div'> & { itemsPerRow?: number }) => (
  <div
    style={{ ['--size' as string]: `${100 / (itemsPerRow || 1)}%` }}
    className={cn(
      'fields-group',
      'flex-[1 1 0] box-border flex flex-wrap [&_.field-wrapper]:shrink',
      {
        '[&_.field-wrapper]:w-(--size) [&_.field-wrapper]:max-w-(--size) [&_.field-wrapper]:basis-(--size)':
          !!itemsPerRow
      },
      className
    )}
    {...restProps}
  />
);

const Focus = ({ className, ref, ...restProps }: React.ComponentProps<'input'>) => (
  <input ref={ref} className={cn('focus-input hidden h-0 w-0', className)} {...restProps} />
);

const Body = ({ className, ...restProps }: React.ComponentProps<'div'>) => (
  <div className={cn('box-border rounded-t-[inherit] bg-white p-6', className)} {...restProps} />
);

const Footer = ({ className, ...restProps }: React.ComponentProps<'div'>) => (
  <div
    className={cn(
      'flex items-center justify-end gap-4 rounded-b-[inherit] border-t border-border bg-white px-6 py-4 shadow-base',
      className
    )}
    {...restProps}
  />
);

const Line = ({ gap = 0, className, ...restProps }: React.ComponentProps<'hr'> & { gap?: number }) => (
  <hr
    style={{ ['--gap' as string]: `${gap}px` }}
    className={cn('mx-auto h-px w-[calc(100%-2*var(--gap))] bg-border', className)}
    {...restProps}
  />
);

const TwoDayPickersInARow = ({ className, ...restProps }: React.ComponentProps<'div'>) => (
  <div
    className={cn(
      'flex items-center',
      '[& > div]:w-full',
      '[& > div]:input:w-full [& > div]:input:min-w-[80px]',
      className
    )}
    {...restProps}
  />
);

export const Form = {
  Line,
  Body,
  Field,
  Focus,
  Fields,
  Footer,
  SectionTitle,
  TwoDayPickersInARow,
  Provider: FormProvider
};
